import PropTypes from 'prop-types';
import React from 'react';

import MessengerSharingIcon from './sharing-icons/MessengerShareButton';
import TwitterSharingIcon from './sharing-icons/TwitterShareButton';
import WhatsAppSharingIcon from './sharing-icons/WhatsAppShareButton';

import './SocialSharing.less';

const Icon = ({ iconStyle, style, details }) => {
  let icon;
  switch (details.socialPlatform) {
    case 'whatsapp':
      icon = <WhatsAppSharingIcon sharingDetails={details} iconStyle={iconStyle} style={style} />;
      break;
    case 'messenger':
      icon = <MessengerSharingIcon sharingDetails={details} iconStyle={iconStyle} style={style} />;
      break;
    case 'twitter':
      icon = <TwitterSharingIcon sharingDetails={details} iconStyle={iconStyle} style={style} />;
      break;
    default:
      throw new Error('Unknown sharing type');
  }
  return icon;
};

const SocialSharing = ({ style, iconStyle, sharingDetails }) =>
  sharingDetails.map((details) => (
    <Icon key={details.socialPlatform} iconStyle={iconStyle} style={style} details={details} />
  ));

SocialSharing.propTypes = {
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  iconStyle: PropTypes.shape({
    size: PropTypes.oneOf([16, 24]),
    className: PropTypes.string,
    title: PropTypes.string,
  }),
  sharingDetails: PropTypes.arrayOf(
    PropTypes.shape({
      socialPlatform: PropTypes.string,
      onClickToShare: PropTypes.func,
    }),
  ),
};

SocialSharing.defaultProps = {
  style: {},
  iconStyle: {
    size: 24,
    className: '',
    title: '',
  },
  sharingDetails: [
    {
      socialPlatform: 'whatsapp',
      text: 'https://wise.com/',
    },
    {
      socialPlatform: 'messenger',
      appId: '120387148077990',
      url: 'https://wise.com/',
      redirectURL: 'https://wise.com/',
    },
    {
      socialPlatform: 'twitter',
      text: 'https://wise.com/',
      hashtags: ['Wise'],
    },
  ],
};

export default SocialSharing;
